var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"up-success"},_vm.$listeners),[_c('img',{attrs:{"src":_vm.upImgThumb,"alt":""}}),_c('p',{staticClass:"tip"},[_vm._v("上传成功")])])}
var staticRenderFns = []

export { render, staticRenderFns }